(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["loomish-discover-spotlight"] && !Shopify.designMode) return;
  try {
    
/* ═══════════════════════════════════════════════════════════════════════════
   LOOMISH DISCOVER SPOTLIGHT — JavaScript
   GSAP + ScrollTrigger required (loaded globally in theme.liquid)
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  if (typeof gsap === 'undefined') {
    console.warn('Loomish Discover: GSAP not found.');
    return;
  }
  if (typeof ScrollTrigger !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger);
  }

  /* ── LoomishSpotlight ────────────────────────────────────────────────── */
  class LoomishSpotlight {
    constructor(sectionEl) {
      this.section  = sectionEl;
      this.track    = sectionEl.querySelector('.loomish-discover__track');
      this.cards    = Array.from(sectionEl.querySelectorAll('.loomish-discover__card'));
      this.dots     = Array.from(sectionEl.querySelectorAll('.loomish-discover__dot'));
      this.prevBtn  = sectionEl.querySelector('.loomish-discover__nav-btn--prev');
      this.nextBtn  = sectionEl.querySelector('.loomish-discover__nav-btn--next');
      this.cursorEl = document.getElementById('loomish-cursor-' + sectionEl.dataset.sectionId);

      this.total         = this.cards.length;
      this.currentIndex  = 0;
      this.animating     = false;
      this.autoTimer     = null;
      this.isMobile      = window.matchMedia('(max-width: 767px)').matches;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (this.total === 0) return;

      this.section.classList.add('is-js-ready');
      this.isMobile ? this.setupMobile() : this.setupDesktop();
      this.bindShared();
    }

    /* ── Desktop ─────────────────────────────────────────────────────────── */

    setupDesktop() {
      const offset = this.sideOffset();

      this.cards.forEach((card, i) => {
        const state = this.stateOf(i, 0);
        gsap.set(card, {
          xPercent : -50,
          yPercent : -50,
          y        : 32,           // shifted down; ScrollTrigger animates to 0
          ...this.propsOf(state, offset),
        });
        card.dataset.slot = state;
      });

      // Underglow starts invisible; ScrollTrigger fades it in with the hero
      const firstGlow = this.cards[0].querySelector('.loomish-discover__underglow');
      if (firstGlow) gsap.set(firstGlow, { opacity: 0 });

      this.syncNav(0);
      this.setupScrollEntrance();
      this.setupCursor();

      this.section.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft')  this.prev();
        if (e.key === 'ArrowRight') this.next();
      });
    }

    /* ── Geometry helpers ───────────────────────────────────────────────── */

    sideOffset() {
      const W   = this.section.offsetWidth;
      const gap = Math.max(60, W * 0.048);  // 4.8% of section, min 60px
      return 190 + gap + 114;               // half hero + gap + half side-card
    }

    // State name relative to a given hero index
    stateOf(cardIndex, heroIndex) {
      const d = cardIndex - heroIndex;
      if (d === 0)  return 'center';
      if (d === -1) return 'left';
      if (d === 1)  return 'right';
      return d < 0 ? 'hidden-left' : 'hidden-right';
    }

    // State name → GSAP property bundle
    propsOf(state, offset) {
      const o = offset || this.sideOffset();
      switch (state) {
        case 'hidden-left':  return { x: -o * 2.0, scale: 0.38, autoAlpha: 0,   filter: 'saturate(0.3)' };
        case 'left':         return { x: -o,        scale: 0.60, autoAlpha: 0.5, filter: 'saturate(0.7)' };
        case 'center':       return { x: 0,         scale: 1.00, autoAlpha: 1,   filter: 'saturate(1)'   };
        case 'right':        return { x: o,         scale: 0.60, autoAlpha: 0.5, filter: 'saturate(0.7)' };
        case 'hidden-right': return { x: o * 2.0,   scale: 0.38, autoAlpha: 0,   filter: 'saturate(0.3)' };
      }
    }

    /* ── Core transition ────────────────────────────────────────────────── */

    goTo(newIndex, instant) {
      if (newIndex < 0 || newIndex >= this.total) return;
      if (newIndex === this.currentIndex && !instant) return;
      if (this.animating) return;

      this.animating = true;
      const dur    = (this.reducedMotion || instant) ? 0.01 : 0.8;
      const offset = this.sideOffset();
      const fwd    = newIndex > this.currentIndex;

      this.currentIndex = newIndex;

      // Pre-position cards entering from off-screen so they slide in cleanly
      this.cards.forEach((card, i) => {
        const wasHidden = card.dataset.slot === 'hidden-left' || card.dataset.slot === 'hidden-right';
        const newState  = this.stateOf(i, newIndex);
        const becomesVisible = newState === 'left' || newState === 'right';

        if (wasHidden && becomesVisible) {
          const entryX = fwd ? offset * 1.85 : -offset * 1.85;
          gsap.set(card, { x: entryX, scale: 0.35, autoAlpha: 0, y: 0 });
        }
        card.dataset.slot = newState;
      });

      const tl = gsap.timeline({ onComplete: () => { this.animating = false; } });

      this.cards.forEach((card, i) => {
        const state    = this.stateOf(i, newIndex);
        const isCenter = i === newIndex;
        const props    = this.propsOf(state, offset);

        tl.to(card, {
          ...props,
          y        : 0,
          duration : dur,
          ease     : isCenter
            ? `back.out(${this.reducedMotion ? 1 : 1.5})`
            : 'power3.inOut',
        }, 0);

        // Toggle hero class for CSS-driven side effects
        card.classList.toggle('is-hero', isCenter);

        // Underglow: fades out on old hero, fades in on new hero
        const glow = card.querySelector('.loomish-discover__underglow');
        if (glow) {
          tl.to(glow, {
            opacity  : isCenter ? 1 : 0,
            duration : dur * 0.75,
            delay    : isCenter ? dur * 0.28 : 0,
            ease     : 'power2.out',
          }, 0);
        }
      });

      this.syncDots(newIndex);
      this.syncNav(newIndex);
    }

    prev() { this.goTo(this.currentIndex - 1); }
    next() { this.goTo(this.currentIndex + 1); }

    /* ── UI sync ────────────────────────────────────────────────────────── */

    syncDots(index) {
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
    }

    syncNav(index) {
      if (this.prevBtn) this.prevBtn.disabled = index === 0;
      if (this.nextBtn) this.nextBtn.disabled = index === this.total - 1;
    }

    /* ── Auto-rotate ────────────────────────────────────────────────────── */

    startAuto() {
      if (this.section.dataset.autoRotate !== 'true' || this.reducedMotion) return;
      this.stopAuto();
      this.autoTimer = setInterval(() => {
        this.goTo(this.currentIndex + 1 >= this.total ? 0 : this.currentIndex + 1);
      }, 6000);
    }

    stopAuto() {
      clearInterval(this.autoTimer);
      this.autoTimer = null;
    }

    /* ── Scroll entrance ────────────────────────────────────────────────── */

    setupScrollEntrance() {
      const headerEls = [
        this.section.querySelector('.loomish-discover__eyebrow'),
        this.section.querySelector('.loomish-discover__hairline'),
        this.section.querySelector('.loomish-discover__headline'),
        this.section.querySelector('.loomish-discover__subline'),
      ].filter(Boolean);

      if (typeof ScrollTrigger === 'undefined') {
        // Fallback: show immediately if ScrollTrigger is absent
        gsap.set(headerEls, { opacity: 1, y: 0 });
        return;
      }

      ScrollTrigger.create({
        trigger : this.section,
        start   : 'top 80%',
        once    : true,
        onEnter : () => {
          // 1 — Header: eyebrow → hairline → headline → subline
          gsap.fromTo(headerEls,
            { opacity: 0, y: 24 },
            { opacity: 1, y: 0, duration: 0.8, ease: 'power2.out', stagger: 0.15 }
          );

          // 2 — Cards: left + right enter first, hero card lands last (climax)
          const offset = this.sideOffset();
          const seq    = [];
          // Build order: left, right, then center
          for (let i = 0; i < this.total; i++) {
            const st = this.stateOf(i, this.currentIndex);
            if (st === 'left')   seq.unshift(i);
            if (st === 'right')  seq.push(i);
          }
          for (let i = 0; i < this.total; i++) {
            if (this.stateOf(i, this.currentIndex) === 'center') seq.push(i);
          }

          seq.forEach((cardIdx, order) => {
            const card  = this.cards[cardIdx];
            const state = this.stateOf(cardIdx, this.currentIndex);
            const props = this.propsOf(state, offset);
            const delay = 0.48 + order * 0.14;

            gsap.to(card, { autoAlpha: props.autoAlpha, y: 0, duration: 0.9, ease: 'power2.out', delay });

            if (state === 'center') {
              const glow = card.querySelector('.loomish-discover__underglow');
              if (glow) gsap.to(glow, { opacity: 1, duration: 0.7, ease: 'power2.out', delay: delay + 0.32 });
            }
          });
        },
      });
    }

    /* ── Custom cursor (desktop) ────────────────────────────────────────── */

    setupCursor() {
      const el    = this.cursorEl;
      const outer = this.section.querySelector('.loomish-discover__carousel-outer');
      if (!el || !outer) return;

      let cx = 0, cy = 0, tx = 0, ty = 0, rafId = null, active = false;

      const tick = () => {
        cx += (tx - cx) * 0.18;
        cy += (ty - cy) * 0.18;
        gsap.set(el, { x: cx, y: cy });
        rafId = requestAnimationFrame(tick);
      };

      outer.addEventListener('mousemove', (e) => {
        tx = e.clientX;
        ty = e.clientY;

        const hero = this.cards[this.currentIndex];
        const r    = hero.getBoundingClientRect();
        const over = e.clientX >= r.left && e.clientX <= r.right
                  && e.clientY >= r.top  && e.clientY <= r.bottom;

        if (over && !active) {
          active       = true;
          el.style.opacity = '1';
          hero.style.cursor = 'none';
          if (!rafId) rafId = requestAnimationFrame(tick);
        } else if (!over && active) {
          active            = false;
          el.style.opacity  = '0';
          hero.style.cursor = '';
        }
      });

      outer.addEventListener('mouseleave', () => {
        active = false;
        el.style.opacity = '0';
        if (this.cards[this.currentIndex]) this.cards[this.currentIndex].style.cursor = '';
      });
    }

    /* ── Mobile setup ───────────────────────────────────────────────────── */

    setupMobile() {
      // First card starts as hero
      this.cards[0].classList.add('is-hero');

      // IntersectionObserver detects which card is centered in the snap container
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.55) {
            const idx = this.cards.indexOf(entry.target);
            this.cards.forEach((c) => c.classList.remove('is-hero'));
            entry.target.classList.add('is-hero');
            this.currentIndex = idx;
            this.syncDots(idx);
          }
        });
      }, { root: this.track, threshold: 0.55 });

      this.cards.forEach((c) => io.observe(c));

      // Mobile header entrance
      const headerEls = [
        this.section.querySelector('.loomish-discover__eyebrow'),
        this.section.querySelector('.loomish-discover__hairline'),
        this.section.querySelector('.loomish-discover__headline'),
        this.section.querySelector('.loomish-discover__subline'),
      ].filter(Boolean);

      if (typeof ScrollTrigger !== 'undefined') {
        ScrollTrigger.create({
          trigger : this.section,
          start   : 'top 80%',
          once    : true,
          onEnter : () => gsap.fromTo(headerEls,
            { opacity: 0, y: 20 },
            { opacity: 1, y: 0, duration: 0.8, ease: 'power2.out', stagger: 0.14 }
          ),
        });
      }

      // Dot taps → smooth scroll to that card
      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          this.cards[i].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        });
      });
    }

    /* ── Shared bindings (both viewports) ───────────────────────────────── */

    bindShared() {
      if (!this.isMobile) {
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goTo(i)));
        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.prev());
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.next());
      }

      this.startAuto();
      this.section.addEventListener('mouseenter', () => this.stopAuto());
      this.section.addEventListener('mouseleave', () => this.startAuto());
      this.section.addEventListener('touchstart',  () => this.stopAuto(), { passive: true });

      // Reflow card positions when container width changes (desktop only)
      let resizeT;
      window.addEventListener('resize', () => {
        clearTimeout(resizeT);
        resizeT = setTimeout(() => {
          if (window.matchMedia('(max-width: 767px)').matches) return;
          const offset = this.sideOffset();
          this.cards.forEach((card, i) => {
            const state = this.stateOf(i, this.currentIndex);
            if (state !== 'hidden-left' && state !== 'hidden-right') {
              gsap.set(card, { x: this.propsOf(state, offset).x });
            }
          });
        }, 220);
      });
    }
  }

  /* ── Bootstrap ────────────────────────────────────────────────────────── */
  function boot() {
    document.querySelectorAll('.loomish-discover:not([data-spotlight-init])').forEach((el) => {
      el.dataset.spotlightInit = 'true';
      new LoomishSpotlight(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init after Shopify theme editor section reload
  document.addEventListener('shopify:section:load', (e) => {
    const el = e.target.querySelector('.loomish-discover');
    if (el && !el.dataset.spotlightInit) {
      el.dataset.spotlightInit = 'true';
      new LoomishSpotlight(el);
    }
  });

}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
